import React, { lazy } from 'react';
import { Route } from 'react-router';
import routes from '../routes';
import Authenticated from '../../components/auth/Authenticated';

const ArticleListScreen = lazy(() => import('../../screens/Article/screens/List'));
const ArticleViewScreen = lazy(() => import('../../screens/Article/screens/View'));
const ArticleCreateScreen = lazy(() => import('../../screens/Article/screens/Create'));
const ArticleEditScreen = lazy(() => import('../../screens/Article/screens/Edit'));

const articleRoutes = [
    <Route
        exact
        key={routes.ARTICLE_LIST}
        path={routes.ARTICLE_LIST}
        render={() => (
            <Authenticated redirectTo={routes.USER_LIST}>
                <ArticleListScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.ARTICLE_VIEW}
        path={routes.ARTICLE_VIEW}
        render={() => (
            <Authenticated redirectTo={routes.ARTICLE_LIST}>
                <ArticleViewScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.ARTICLE_CREATE}
        path={routes.ARTICLE_CREATE}
        render={() => (
            <Authenticated redirectTo={routes.ARTICLE_LIST}>
                <ArticleCreateScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.ARTICLE_EDIT}
        path={routes.ARTICLE_EDIT}
        render={() => (
            <Authenticated redirectTo={routes.ARTICLE_LIST}>
                <ArticleEditScreen />
            </Authenticated>
        )}
    />,
];

export default articleRoutes;
